import * as types from "@/store/types/mutation-types";

const mutations = {};

// User

mutations[types.SET_USER] = (state, data) => {
  state.currentUser = data;
};

mutations[types.SET_USER_PROFILE] = (state, data) => {
  state.currentUserProfile = data;
};

// Devices

mutations[types.SET_USERS_DEVICES] = (state, data) => {
  state.currentUsersDevices = data;
};

// Relationships

mutations[types.SET_RELATIONSHIPS] = (state, data) => {
  state.relationships = data;
};

// Specialties

mutations[types.SET_SPECIALTIES] = (state, data) => {
  state.specialties = data;
};

// Share History

mutations[types.SET_SHARE_HISTORY] = (state, data) => {
  state.shareHistory = data;
};

mutations[types.POST_SHARE_HISTORY] = (state, data) => {
  state.postShareHistory = data;
};

// Readings
mutations[types.SET_LATEST_READING_FOR_DEVICE] = (state, data) => {
  state.latestReadingsForDevice = data;
};
mutations[types.SET_LATEST_READINGS_FOR_TODAY] = (state, data) => {
  state.isLatestReadingToday = data;
};
mutations[types.SET_READING_FOR_BP_CUFF] = (state, data) => {
  state.readingsForBP_CUFF = data;
};
mutations[types.SET_READING_FOR_SCALE] = (state, data) => {
  state.readingsForSCALE = data;
};
mutations[types.SET_READING_FOR_GLUCOMETER] = (state, data) => {
  state.readingsForGLUCOMETER = data;
};
mutations[types.SET_READING_FOR_THERMOMETER] = (state, data) => {
  state.readingsForTHERMOMETER = data;
};
mutations[types.SET_READING_FOR_PULSE_OXIMETER] = (state, data) => {
  state.readingsForPULSE_OXIMETER = data;
};

// Word Game
mutations[types.SET_WORD_GAME_WORD] = (state, data) => {
  state.solution = data;
};
mutations[types.SET_ALL_WORD_GAME_WORDS] = (state, data) => {
  state.allWordGameWords = data;
};
mutations[types.SET_GUESSED_WORD] = (state, data) => {
  state.attemptedWord = data;
};
mutations[types.GET_ALL_GUESSED_WORDS] = (state, data) => {
  state.getAllGuessedWords = data;
};
mutations[types.SET_GUESSES] = (state, data) => {
  state.guesses = data;
};
mutations[types.UPDATE_WORD_GAME] = (state, data) => {
  state.wordGame = data;
};
mutations[types.SET_WORD_GAME_WORD_ID] = (state, data) => {
  state.wordGameWordId = data;
};
mutations[types.SET_WORD_GAME_ID] = (state, data) => {
  state.wordGameId = data;
};
mutations[types.SET_CURRENT_STREAK] = (state, data) => {
  state.currentStreak = data;
};
mutations[types.SET_BEST_STREAK] = (state, data) => {
  state.bestStreak = data;
};
mutations[types.UPDATE_ATTEMPTED_GUESSES] = (state, data) => {
  state.currentGuessIndex = data;
};
mutations[types.UPDATE_GAME_WON] = (state, data) => {
  state.gameWon = data;
};
mutations[types.SAVE_WORD_ROW] = (state, data) => {
  state.wordGameWordRow = data;
};
mutations[types.UPDATE_PLAYING_GAME] = (state, data) => {
  state.playingGame = data;
};
mutations[types.SET_GAME_RECORD] = (state, data) => {
  state.gameRecord = data;
};
mutations[types.SET_HINT] = (state, data) => {
  state.hint = data;
};
mutations[types.SET_MISS] = (state, data) => {
  state.miss = data;
};
mutations[types.SET_FOUND] = (state, data) => {
  state.found = data;
};
mutations[types.UPDATE_LETTERS_GUESSED] = (state, { guessedLetter, type }) => {
  if (type === "found") {
    state.found.add(guessedLetter);
  } else if (type === "hint") {
    state.hint.add(guessedLetter);
  } else if (type === "miss") {
    state.miss.add(guessedLetter);
  }
};
mutations[types.SET_LETTER_BOX_COLORS] = (state, data) => {
  state.letterBoxColors = data;
};
mutations[types.SET_PREVIOUS_GAME_RECORD] = (state, data) => {
  state.previousGameRecord = data;
};
export default mutations;
